"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SLOT_ELEMENTS = exports.COMPLEX_ELEMENTS = exports.COMMON_NODES = void 0;
const Accordion_1 = __importDefault(require("../elements/elements/Accordion"));
const LayoutList_1 = __importDefault(require("../elements/elements/LayoutList"));
const Slider_1 = __importDefault(require("../elements/elements/Slider"));
const Tabs_1 = __importDefault(require("../elements/elements/Tabs"));
const Button_1 = __importDefault(require("../elements/elements/Button"));
const enums_1 = require("./enums");
exports.COMMON_NODES = [enums_1.NodeType.row, enums_1.NodeType.column, enums_1.NodeType.absolute, enums_1.NodeType.node];
exports.COMPLEX_ELEMENTS = [Tabs_1.default.type, Accordion_1.default.type, Slider_1.default.type, LayoutList_1.default.type];
exports.SLOT_ELEMENTS = [Button_1.default.type];
